import React from "react";
import "./Consultancy.css"
import config from '../../../website-config';
const Consultancy = () => (
   <>
    <section id="about" className="about section-bg">
        <div className="container">
        <div className="section-title">
              <h6>Let's Chat</h6>
            </div>
          <div className="row">
            <div className="col-lg-6 contact-box" >
              {/* <form action='index.php' method='POST' >
                <div className="row">
                  <div className="col">
                <div data-sal="slide-up"className="form-outline mb-4 ">
                  <input name="name" type="text" id="name" className="form-control" />
                  <label className="form-label" for="name">Name</label>
                </div>
                  </div>
                  <div className="col">
                <div data-sal="slide-up"className="form-outline mb-4">
                  <input name="email" type="email" id="registerEmail" className="form-control" />
                  <label className="form-label" for="registerEmail">Email</label>
                </div>
                  </div>
                </div>

                <div data-sal="slide-up"className="form-outline mb-4">
                  <input name="phone"type="tel"  id="registerPhone" className="form-control" />
                  <label className="form-label" for="registerPhone">Phone</label>
                </div>

               <div className="row">
               <div className="col">
                <select name="company-category" data-sal="slide-up"className="browser-default custom-select mb-4">
                  <option value="0"selected>Company Category</option>
                  <option value="Automotive ">Automotive </option>
                  <option value="Business Support & Supplies">Business Support & Supplies</option>
                  <option value="Computers & Electronics">Computers & Electronics</option>
                  <option value="Construction & Contractors">Construction & Contractors</option>
                  <option value="Education">Education</option>
                  <option value="Entertainment">Entertainment</option>
                  <option value="Food & Dining">Food & Dining</option>
                  <option value="Health & Medicine">Health & Medicine</option>
                  <option value="Home & Garden ">Home & Garden </option>
                  <option value="Legal & Financial">Legal & Financial </option>
                  <option value="Manufacturing, Wholesale, Distribution">Manufacturing, Wholesale, Distribution  </option>
                  <option value="Merchants (Retail)">Merchants (Retail)  </option>
                  <option value="Personal Care & Services">Personal Care & Services  </option>
                  <option value="Real Estate">Real Estate  </option>
                  <option value="Travel & Transportation">Travel & Transportation  </option>
                </select>
               </div>
              <div className="col">
                  <select name="total-employees" data-sal="slide-up"className="browser-default custom-select mb-4">
                  <option value="0"selected>No of Employes</option>
                  <option value="1-2">1-2</option>
                  <option value="10-50">10-50</option>
                  <option value="50-150">50-150</option>
                  <option value="150-700">150-700</option>
                  <option value="More than 700">More than 700</option>
                </select>
              </div>
               </div>
                <button data-sal="slide-up"type="submit" className="btn btn-primary mb-1">Submit<i  className="fas fa-lock ml-4"></i></button>
              </form> */}
        <div className="row m-0">
          <div className="col  d-flex justify-content-center align-items-center">
          <lottie-player src="https://assets8.lottiefiles.com/private_files/lf30_ZZ5e24.json"  background="transparent"  speed="0.5"  style={{width: "10rem", height: "10rem"}}  loop  autoplay></lottie-player>
          </div>
          <div className="col d-flex justify-content-center align-items-center">
          <h4 style={{textAlign: 'center'}}>   Call:  <a href={"tel:+" + config.callNumber}>{config.callNumber}</a> </h4>
  <br/>
          </div>
        <h4  style={{textAlign: 'center'}}>We'll rush a Free Brochure/Quote as soon as we hear from you.</h4>
      </div>

            </div>
            <div  className="p-5 col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center">
              <h3 style={{color:"#2D94F3"}}>Let's Take Your Business Online</h3>
              <p data-sal="slide-up" >
          Wordpress | Custome Website & Web App
              </p>
              <ul>
                <li>
                <i className="fas fa-code"></i>
                  <div data-sal="slide-up">
                    <h5>Why my Business needs a Website /Web App?</h5>
                  <p>It will work 24x7 for you</p>
                    

                  </div>
                </li>
                <li>
                <i className="fas fa-chart-line" style={{ color: " #e80368" }}></i>
                  <div data-sal="slide-up">
                    <h5>Business Growth</h5>
                    <p>Unlock massive amounts of Revenue with High Conversion Website </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>



   </>
  );
  export default Consultancy;